import { render, staticRenderFns } from "./globalLayout.vue?vue&type=template&id=98ca0fe8&scoped=true&"
import script from "./globalLayout.vue?vue&type=script&lang=js&"
export * from "./globalLayout.vue?vue&type=script&lang=js&"
import style0 from "./globalLayout.vue?vue&type=style&index=0&id=98ca0fe8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ca0fe8",
  null
  
)

export default component.exports